export default "__VITE_ASSET__vUc0pXJz__"